import React from "react";

type StatCardProps = {
  label: string;
  value: React.ReactNode;
  icon: React.ReactNode;
  tone?: "blue" | "emerald" | "purple" | "slate";
};

const toneClasses: Record<NonNullable<StatCardProps["tone"]>, string> = {
  blue: "bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300",
  emerald: "bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300",
  purple: "bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300",
  slate: "bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200",
};

export function StatCard({ label, value, icon, tone = "slate" }: StatCardProps) {
  return (
    <div className="card p-3 sm:p-4 flex items-center gap-2.5 sm:gap-3 bg-[var(--color-panel)]/90">
      <div className={`p-1.5 sm:p-2 rounded-lg ${toneClasses[tone]}`}>{icon}</div>
      <div className="space-y-0.5 sm:space-y-1">
        <div className="text-[0.65rem] sm:text-xs uppercase tracking-wide text-[var(--color-muted)] leading-none">
          {label}
        </div>
        <div className="text-base sm:text-xl font-semibold leading-snug">{value}</div>
      </div>
    </div>
  );
}
